import {getLCP, getCLS, onINP} from 'web-vitals';
import 'modules/shop-the-look';

const addToGlobal = (...propTuple) => {
  propTuple.forEach(([name, value]) => {
    window[name] = value;
  });
};

addToGlobal(
  ['getLCP', getLCP],
  ['getCLS', getCLS],
  ['onINP', onINP],
);

$(function() {
  $('.js-shop-the-look-modal').shopTheLookModal();
  $('#editorPickSection').on('shopTheLookLoaded', function() {
    $('.js-shop-the-look-modal').shopTheLookModal();
  });

  const searchParams = new URLSearchParams(window.location.search);
  if (searchParams.get(window.rcProps.clearWishlistUrlParam) === 'true') {
    $.modal({
      url: window.rcProps.oldWishlistRemovedModalHref,
      type: 'notification',
      triggerOpen: true,
    });
  }
})

/**
 * Logs engagement to engagement_tracking with details column data
 * @param url - string
 * @param module - string
 * @param action - string
 * @param details - string
 */
window.logEngagementWithDetails = function logEngagementWithDetails(url, module, action, details) {
  $.ajax({
    type: 'POST',
    data: $.param({
      url: url,
      module: module,
      action: action,
      details: details
    }),
    url: '/r/ajax/LogEngagement.jsp'
  });
}



// WEBPACK FOOTER //
// ./src/scripts/entry-points/chrome/global.js